import { Box, Button, Stack, Typography, useTheme } from "@mui/material";

import psLogo from "../../../../assets/perfect-scale.png";
import { useDarkThemeCheck } from "../../../../Components/hooks/useDarkThemeCheck";
import { CircularProgressWithLabel } from "../../../../Components/ProgressWithLabel";

const Fsk8sBanner = () => {
  const theme = useTheme();
  const isDarkMode = useDarkThemeCheck();

  return (
    <Box
      minHeight="100%"
      sx={{ backgroundColor: theme.palette.general.backgroundDark, width: "100%" }}
      p={4}
      display="flex"
      flexDirection="column"
      gap={2}
    >
      <Box alignItems="center" display="flex" width="100%" justifyContent="space-between">
        <img src={psLogo} alt="PerfectScale by DoiT" height={51} />
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center">
          <Box>
            <CircularProgressWithLabel
              size={48}
              value={50}
              backgroundColor={theme.palette.statusWarning[isDarkMode ? "dark" : "light"]}
              color="warning"
              typographyProps={{
                variant: "h4",
                fontWeight: 500,
                color: "textPrimary",
              }}
            />
          </Box>
          <Stack>
            <Typography variant="subtitle1">Savings potential</Typography>
            <Typography variant="body2" color="textSecondary">
              Based on your current usage
            </Typography>
          </Stack>
        </Stack>
      </Box>
      <Stack spacing={3} alignItems="center" justifyContent="center" flexGrow={1}>
        <Stack spacing={1} textAlign="center">
          <Typography variant="h3">Unlock Deeper Insights & Optimize Your Kubernetes Operations</Typography>
          <Typography variant="body1">
            Gain full visibility, smarter recommendations, and cost-saving opportunities—built for DevOps teams who want
            more control, better efficiency, and actionable data.
          </Typography>
        </Stack>
        <Box display="flex" justifyContent="center" width="100%">
          <Button
            variant="contained"
            href="https://www.perfectscale.io/platform"
            target="_blank"
            rel="noopener noreferrer"
          >
            Start for free
          </Button>
        </Box>
      </Stack>
    </Box>
  );
};

export default Fsk8sBanner;
